import React from 'react';
import __ from 'lodash';

class DropdownKurikulum extends React.Component {
    render() {
        const { listKurikulum } = this.props;
        return (
            <>
                {
                    !__.isEmpty(listKurikulum) ?
                        listKurikulum.map((kurikulum) => (
                            <option key={kurikulum.idKurikulum} value={kurikulum.idKurikulum}>{kurikulum.namaKurikulum}</option>
                        ))
                        :
                        <>
                            <option key="1" value="1">KTSP</option>
                            <option key="2" value="2">K-13</option>
                            <option key="3" value="3">K-13 Revisi</option>
                        </>

                }
            </>
        );
    }
}

export default DropdownKurikulum;